"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeSlotSelection = void 0;
var _react = require("react");
var _TimeSlotSelection = require("./TimeSlotSelection.styles");
var _TimeSlotSelection2 = require("./TimeSlotSelection.labels");
var _hooks = require("../../hooks");
var _Select = require("../../UI/Select");
var _jsxRuntime = require("react/jsx-runtime");
const TimeSlotSelection = props => {
  const styles = (0, _TimeSlotSelection.useStyles)();
  const {
    onChange,
    options = [{
      value: 1,
      unit: 'week'
    }, {
      value: 2,
      unit: 'week'
    }, {
      value: 3,
      unit: 'week'
    }],
    value = {
      value: 2,
      unit: 'week'
    }
  } = props;
  const getLabel = (0, _hooks.useLabels)({
    labels: _TimeSlotSelection2.labels
  });
  const [selectedOption, setSelectedOption] = (0, _react.useState)({
    value: value.value,
    label: getLabel(`${value.unit}_${value.value}`)
  });
  const timeSlotOptions = options.map(option => {
    return {
      value: option.value,
      label: getLabel(`${option.unit}_${option.value}`)
    };
  });
  const handleSelectOption = option => {
    setSelectedOption(option);
    onChange(option);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-TimeSlotSelection'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.Select, {
      options: timeSlotOptions,
      btnProps: {
        view: 'text'
      },
      value: selectedOption,
      onChange: handleSelectOption
    })
  });
};
exports.TimeSlotSelection = TimeSlotSelection;